import React, {useState} from 'react';
import { Button } from './Styles';
  
const ScrollButton = () =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    <Button className="d-none d-sm-block">
     <i onClick={scrollToTop} 
     style={{display: visible ? 'inline' : 'none'}} className="bi bi-arrow-up p-2 rounded shadow-sm"/>
    </Button>
  );
}
  
export default ScrollButton;